export default [
    {
        path: '/testing/details',
        name: '练习详情',
        component: r => require.ensure([], () => r(require('@/views/testing/details')), 'user')
    },
    {
        path: '/testing/play',
        name: '开始练习',
        component: r => require.ensure([], () => r(require('@/views/testing/play')), 'user')
    },
    {
        path: '/testing/test',
        name: '开始测试',
        component: r => require.ensure([], () => r(require('@/views/testing/test')), 'user')
    },


]


// WEBPACK FOOTER //
// ./src/router/routers/testing.js